/**
 * @generated SignedSource<<9033b6f2fe46d300a1420977c127eae3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InspectionFieldMap$data = {
  readonly field: {
    readonly geometry: any | null;
    readonly " $fragmentSpreads": FragmentRefs<"FieldMap">;
  } | null;
  readonly " $fragmentType": "InspectionFieldMap";
};
export type InspectionFieldMap$key = {
  readonly " $data"?: InspectionFieldMap$data;
  readonly " $fragmentSpreads": FragmentRefs<"InspectionFieldMap">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InspectionFieldMap",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FieldNode",
      "kind": "LinkedField",
      "name": "field",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FieldMap"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "geometry",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "InspectionfieldNode",
  "abstractKey": null
};

(node as any).hash = "4c27d59ebac6a66ec52a0a060cfa9853";

export default node;
